<template>
  <div class="personal-layout">
    <router-view />
  </div>
</template>
